// extracted by mini-css-extract-plugin
export var columnList = "_bp-0";